"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Container = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Constant = require("../../Constant");

var _styledTheming = _interopRequireDefault(require("styled-theming"));

var _ = require("./");

var _hooks = require("../../hooks");

var _theme, _theme2, _theme3;

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  padding: 0;\n  background-color: ", ";\n  height: inherit;\n\n  @media print, screen and (min-width: ", "px) {\n    background-color: ", ";\n    margin: 0 -15px 0 -15px;\n    width: 25%;\n    max-width: 360px;\n    position: fixed;\n    display: block;\n    height: 100vh;\n    /* border defines sidebar for Windows high contrast users */\n    border-right: 1px solid ", ";\n    overflow: scroll;\n    scrollbar-width: none; /* Firefox */\n    -ms-overflow-style: none; /* Internet Explorer 11 */\n    &::-webkit-scrollbar {\n      /** WebKit */\n      display: none;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var sidebarBgColor = (0, _styledTheming.default)('mode', (_theme = {}, (0, _defineProperty2.default)(_theme, _Constant.Themes.HOMEBRIDGE, _Constant.Color.WHITE), (0, _defineProperty2.default)(_theme, "homepoint", _Constant.Color.HOMEPOINT_NAVY), (0, _defineProperty2.default)(_theme, _Constant.Themes.SYNERGY_ONE, _Constant.Color.WHITE), (0, _defineProperty2.default)(_theme, "caliber", _Constant.Color.CALIBER_BLUE), (0, _defineProperty2.default)(_theme, "figure", _Constant.Color.MOODY_BLURPLE), (0, _defineProperty2.default)(_theme, "petersendean", _Constant.Color.MOODY_BLURPLE), (0, _defineProperty2.default)(_theme, "pella", _Constant.Color.MOODY_BLURPLE), (0, _defineProperty2.default)(_theme, _Constant.Themes.GUARANTEED_RATE, _Constant.Color.WHITE), _theme));
var sidebarBgColorMobile = (0, _styledTheming.default)('mode', (_theme2 = {}, (0, _defineProperty2.default)(_theme2, _Constant.Themes.HOMEBRIDGE, _Constant.Color.HOMEBRIDGE_BLUE), (0, _defineProperty2.default)(_theme2, "homepoint", _Constant.Color.HOMEPOINT_NAVY), (0, _defineProperty2.default)(_theme2, _Constant.Themes.SYNERGY_ONE, _Constant.Color.BLACK), (0, _defineProperty2.default)(_theme2, "caliber", _Constant.Color.CALIBER_BLUE), (0, _defineProperty2.default)(_theme2, "figure", _Constant.Color.MOODY_BLURPLE), (0, _defineProperty2.default)(_theme2, "petersendean", _Constant.Color.MOODY_BLURPLE), (0, _defineProperty2.default)(_theme2, "pella", _Constant.Color.MOODY_BLURPLE), (0, _defineProperty2.default)(_theme2, _Constant.Themes.GUARANTEED_RATE, _Constant.Color.GUARANTEED_RATE_ARROW_RED), _theme2));
var sidebarRightBorder = (0, _styledTheming.default)('mode', (_theme3 = {}, (0, _defineProperty2.default)(_theme3, _Constant.Themes.HOMEBRIDGE, _Constant.Color.GREY_3), (0, _defineProperty2.default)(_theme3, "homepoint", 'transparent'), (0, _defineProperty2.default)(_theme3, _Constant.Themes.SYNERGY_ONE, _Constant.Color.GREY_3), (0, _defineProperty2.default)(_theme3, "caliber", 'transparent'), (0, _defineProperty2.default)(_theme3, "figure", 'transparent'), (0, _defineProperty2.default)(_theme3, "petersendean", 'transparent'), (0, _defineProperty2.default)(_theme3, "pella", 'transparent'), (0, _defineProperty2.default)(_theme3, _Constant.Themes.GUARANTEED_RATE, _Constant.Color.GREY_3), _theme3));

var Container = _styledComponents.default.aside(_templateObject(), sidebarBgColorMobile, _Constant.Width.MD, sidebarBgColor, sidebarRightBorder);

exports.Container = Container;

var TwoColumnSidebar = function TwoColumnSidebar(_ref) {
  var menuList = _ref.menuList,
      render = _ref.render,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["menuList", "render"]);

  // Utilize breakpoints here to determine if the container should render as an aside or a header. This is important to provide accurate landmarks for assistive technology users
  var _useBreakpoints = (0, _hooks.useBreakpoints)(),
      breakpoint = _useBreakpoints.breakpoint;

  var isMobile = breakpoint === _Constant.Breakpoint.SM || breakpoint === _Constant.Breakpoint.XS;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Container, {
    as: isMobile ? 'header' : 'aside'
  }, /*#__PURE__*/_react.default.createElement(_.TwoColumnSidebarMenu, (0, _extends2.default)({
    menuList: menuList
  }, rest)), render()));
};

TwoColumnSidebar.propTypes = {
  menuList: _propTypes.default.arrayOf(_propTypes.default.node),
  render: _propTypes.default.func
};
TwoColumnSidebar.defaultProps = {
  menuList: [],
  render: function render() {
    return null;
  }
};
var _default = TwoColumnSidebar;
exports.default = _default;